import {
  ActorError,
  INTERNAL_ERROR_CODE,
  INTERNAL_ERROR_DESCRIPTION
} from "./chunk-CQQWLB76.js";

// src/common/utils.ts
import { z } from "zod";
var ActorTagsSchema = z.record(z.string());
function assertUnreachable(x) {
  throw new Error(`Unreachable case: ${x}`);
}
function safeStringify(obj, maxSize) {
  let size = 0;
  function replacer(key, value) {
    if (value === null || value === void 0) return value;
    const valueSize = typeof value === "string" ? value.length : JSON.stringify(value).length;
    size += key.length + valueSize;
    if (size > maxSize) {
      throw new Error(`JSON object exceeds size limit of ${maxSize} bytes.`);
    }
    return value;
  }
  return JSON.stringify(obj, replacer);
}
function isJsonSerializable(value, onInvalid, currentPath = "") {
  if (value === null || value === void 0) {
    return true;
  }
  if (typeof value === "number") {
    if (!Number.isFinite(value)) {
      onInvalid == null ? void 0 : onInvalid(currentPath);
      return false;
    }
    return true;
  }
  if (typeof value === "boolean" || typeof value === "string") {
    return true;
  }
  if (Array.isArray(value)) {
    for (let i = 0; i < value.length; i++) {
      const itemPath = currentPath ? `${currentPath}[${i}]` : `[${i}]`;
      if (!isJsonSerializable(value[i], onInvalid, itemPath)) {
        return false;
      }
    }
    return true;
  }
  if (typeof value === "object") {
    if (Object.getPrototypeOf(value) !== Object.prototype) {
      onInvalid == null ? void 0 : onInvalid(currentPath);
      return false;
    }
    for (const key in value) {
      const propPath = currentPath ? `${currentPath}.${key}` : key;
      if (!isJsonSerializable(
        value[key],
        onInvalid,
        propPath
      )) {
        return false;
      }
    }
    return true;
  }
  onInvalid == null ? void 0 : onInvalid(currentPath);
  return false;
}
function deconstructError(error, logger, extraLog) {
  let statusCode;
  let code;
  let message;
  let metadata = void 0;
  if (error instanceof ActorError && error.public) {
    statusCode = 400;
    code = error.code;
    message = String(error);
    metadata = error.metadata;
    logger.info("public error", {
      code,
      message,
      ...extraLog
    });
  } else {
    statusCode = 500;
    code = INTERNAL_ERROR_CODE;
    message = INTERNAL_ERROR_DESCRIPTION;
    metadata = {
      //url: `https://hub.rivet.gg/projects/${actorMetadata.project.slug}/environments/${actorMetadata.environment.slug}/actors?actorId=${actorMetadata.actor.id}`,
    };
    logger.warn("internal error", {
      error: String(error),
      stack: error == null ? void 0 : error.stack,
      ...extraLog
    });
  }
  return { statusCode, code, message, metadata };
}

export {
  ActorTagsSchema,
  assertUnreachable,
  safeStringify,
  isJsonSerializable,
  deconstructError
};
//# sourceMappingURL=chunk-35HYSA7K.js.map